import { render } from "./module.vue?vue&type=template&id=1d027943"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/brands-3/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d027943"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d027943', __exports__)) {
    api.reload('1d027943', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=1d027943", () => {
    api.rerender('1d027943', render)
  })

}


export default __exports__